import LayoutMonitoring from './LayoutMonitoring.vue'
export default LayoutMonitoring



// WEBPACK FOOTER //
// ./src/layouts/LayoutMonitoring/index.js